import React, {FC, SyntheticEvent, useRef} from 'react';
import rocheCrest from '../assets/roche-crest.png';
import {FlexContainer} from '../components/flex-container';
import {MenuIcon} from './menu-icon'
import {navItems} from '../assets/nav-item-list';
import {NavPanel} from './nav-panel';

interface Props {
    title: string;
    subTitle: string;
    height?: string;
    className: string;
    onNavItemClick?: (e: SyntheticEvent, path: string) => void;
}

export const PageBanner: FC<Props> = ({
    title, 
    subTitle,
    className = '',
    onNavItemClick = () => {},
}) => {

    const navMenuRef = useRef<HTMLInputElement | null>(null);

    const onNavItemClicked: Function =(e: SyntheticEvent, path: string) => {
        navMenuRef.current!.classList.toggle('visible');

        onNavItemClick(e, path);
    }


    const onMenuIconClick = () => {
        if(!navMenuRef.current){

            return;
        }
        navMenuRef.current.classList.toggle('visible');
    }

    const style: object = {
        position: 'relative',
        width: '100vw',
        backgroundColor: '#000',
        color: '#fff',
        padding: '5vh 5vw 5vh 5vw',
    }

    const flexStyle: object = {
        height: '100%',
        width: '100%',
    }

    return (
        <div style={style} className={className}>
            <FlexContainer 
                orientation='row'
                vAlign='center'
                hAlign='flex-start'
                style={flexStyle}
            >
                <FlexContainer
                    vAlign='center'
                    hAlign='center'
                    style={{width: 'fit-content'}}
                >
                    <img className='crest-image' src={rocheCrest}/>
                </FlexContainer>
                <FlexContainer
                    orientation='column'
                    vAlign='center'
                    hAlign='flex-start'
                    style={{width: 'fit-content'}}
                >
                    <span 
                        className="page-title"
                    >
                        {title}
                    </span>
                    <span 
                        className="page-subtitle"
                    >
                        {subTitle}
                    </span>
                </FlexContainer>
            </FlexContainer>
            <div className='menu-icon-wrapper'>
                <MenuIcon 
                    color={'#fff'} 
                    onClick={onMenuIconClick}
                />
                <div 
                    ref={navMenuRef} 
                    className='nav-menu-wrapper'
                >
                    <NavPanel 
                        navItems={navItems} 
                        onNavItemClick={onNavItemClicked}
                    />
                </div>
            </div>


        </div>
    )
}

